<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="W8" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gguaed7nylj31hc0tytk7.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1gguam3t5x5j30u01b8gr6.jpg"/>
        <!-- 轮播图 -->
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
        </div>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gguaefwtq6j31hc0crwg9.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gguam6rz3bj30u00gwgnr.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gguaeibjdcj31hc0u0k13.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1gguaeklz8kj31hc0u0qkg.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gguaepohpyj31hc0u0x09.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gguaf3dxc2j31hc0u0qgz.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gguafaceirj31hc0u018e.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gguafcwvbwj31hc0u012r.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1gguaff7ijwj31hc0u0kal.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1gguafhstquj31hc0u0ngf.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1gguafprg4gj31hc0u0wnq.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1gguam9rrqqj30u01b8n4d.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gguamcpxb9j30u01b8dp4.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gguamfdrolj30u01b87gy.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gguamn0favj30u01b8n2l.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gguampu1vgj30u01b8qdl.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1gguamsp6d9j30u01b8tfe.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gguamvhezqj30u01b87es.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gguamz1tc5j30u01b8dza.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
           swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                paginationClickable: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            earphones: ["https://wx1.sinaimg.cn/large/0067mezugy1gguafwoox3j30ai0hngn2.jpg", "https://wx4.sinaimg.cn/large/0067mezugy1gguafzcnclj30dz0g940z.jpg", "https://wx2.sinaimg.cn/large/0067mezugy1ggyxjjud0zj30m00okq58.jpg"],
        }
    },
    methods:{
       
    }
}
</script>
<style scoped>
.pro_animation .swiper-container{
    width: 1000px;
}
.pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev, .pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
    width: 40px;
    height: 70px;
}
.pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev{
    background-image: url(../../../assets/img/arrow_l_2.png);
}
.pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
    background-image: url(../../../assets/img/arrow_r_2.png);
}

@media (max-width: 768px) {
    .pro_animation .swiper-container {
        width: 100%;
    }

    .pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev, .pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
        width: 30px;
        height: 54px;
    }

    .pro_animation_item img{
        width: auto;
        height: 80%;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/products/W/w8.vue